<vs-app-page
  *vsLet="filters$ | async as filters"
  [config]="{
    title: 'Payments',
    icon: 'wallet-03',
    showDivider: true,
    description: 'This is an overview of all payments filed across your organization.'
  }"
>
  <vs-breadcrumbs slot="breadcrumbs" [config]="{ items: [{ label: 'Payments', routerLink: [] }] }"></vs-breadcrumbs>
  <vs-badge
    *vsLet="setTotalPayments((table.page$ | async)?.meta?.totalItems)"
    slot="title-end"
    [class.italic]="totalPayments === null"
    [class.animate-pulse]="totalPayments === null"
  >
    {{ totalPayments === null ? 'loading' : (totalPayments | number) + ' ' + (totalPayments === 1 ? 'Payment' :
    'Payments') }}
  </vs-badge>

  <a
    *ngIf="exportUrl$ | async as exportUrl"
    vs-button
    theme="primary"
    slot="header-end"
    class="w-full"
    download="payments.csv"
    [href]="exportUrl"
  >
    <vs-icon name="download-01"></vs-icon>
    Export Payments
  </a>

  <form [formGroup]="form">
    <div class="flex gap-2 justify-between items-center flex-wrap mt-4">
      <div class="ml-auto flex items-start gap-2 py-1.5 sm:py-0 w-full sm:w-auto">
        <button
          #filtersTrigger="cdkOverlayOrigin"
          cdkOverlayOrigin
          vs-button
          type="button"
          appearance="outline"
          (click)="$event.preventDefault(); $event.stopImmediatePropagation(); toggleFiltersOverlay()"
        >
          <vs-icon name="sliders-04" slot="start"></vs-icon>
          Filters
          <vs-badge *ngIf="activeFilterCount > 0" class="ml-1" theme="default">{{ activeFilterCount }}</vs-badge>
        </button>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="filtersTrigger"
          [cdkConnectedOverlayOpen]="filtersOverlayOpen"
          [cdkConnectedOverlayPositions]="positions"
          (overlayOutsideClick)="closeFiltersOverlay()"
          (detach)="closeFiltersOverlay()"
        >
          <vs-card class="my-2 !rounded-md !shadow-md" [style.maxWidth]="'min(90vw, 576px)'">
            <div class="p-3 w-[min(90vw,576px)] max-h-[70vh] overflow-y-auto" (click)="$event.stopPropagation()">
              <div class="flex items-center justify-between mb-2">
                <p class="text-sm font-semibold text-themed-900">Filters</p>
                <button vs-button type="button" appearance="clear" size="sm" (click)="clearAllFilters()">
                  Clear all
                </button>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div class="flex flex-col gap-3">
                  <ws-customer-picker formControlName="selectedCustomer"></ws-customer-picker>
                </div>

                <div class="flex flex-col gap-3">
                  <ws-payment-status-picker formControlName="status"></ws-payment-status-picker>
                  <ws-distributor-filter
                    permissionId="py_ViewSales"
                    formControlName="selectedDistributor"
                  ></ws-distributor-filter>
                </div>
              </div>
            </div>
          </vs-card>
        </ng-template>

        <vs-input-container class="min-w-[200px] sm:max-w-[212px] w-full sm:w-auto ml-auto">
          <vs-icon name="search-lg" slot="start"></vs-icon>
          <input
            type="text"
            formControlName="warrantyId"
            placeholder="Warranty id, contract #, reference, or name..."
          />
        </vs-input-container>
      </div>
    </div>
  </form>

  <vs-card class="my-4 overflow-hidden">
    <ws-payments-table #table [filters]="filters" (rowClicked)="rowClicked($event)"></ws-payments-table>
  </vs-card>
</vs-app-page>
